import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react'

import Modal from '@Modal/V3/Modal'

import Input from '@/Form/V2/Input'

import FormStatus from '@/Form/FormStatus'

import Loader from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

import { num, formatNum } from '@root/utility'

const FORM_NAME = 'CheckDeposit';

const { app, moment } = window;

export default function PhoneModal ({ onClose, onSuccess, ...props })
{
	const [status, setStatus] = useState({ });
	const [loading, setLoading] = useState(false);
	const [phone, setPhone] = useState();

	const _ref_ctrl = useRef();
	const _ref_busy = useRef();

// réinitialise la modale une fois masquée pour éviter
// de modifier ce qui est affiché en pleine animation d'ouverture/fermeture
	const handleModalHidden = useCallback(function (params)
	{
		setStatus({ });
	},
	[]);

	const modifiers = useMemo(function ()
	{
		return props.bemit || ['small'];
	},
	[props.bemit]);

	const prevent_close = loading === 'creating';

	const validate = useCallback(function ()
	{
		if (_ref_busy.current) return;
		_ref_busy.current = true;

		setLoading('creating');

		setStatus({ });

		const controller = new AbortController();
		_ref_ctrl.current = controller;

		(async function update ()
		{
			try
			{
				var response = await request('/users/update-my-phone')
				.config({ controller })
				.post(
				{
					phone: phone
				});
			}
			catch (update)
			{
				return setStatus(update);
			}
			finally
			{
				_ref_busy.current = false;
				setLoading(false);
			}

			setStatus(response);
			onClose();

			app.state.session.phone = phone;

			if (typeof onSuccess === 'function') onSuccess();
		})();

		return () => { _ref_ctrl.current?.abort?.(); _ref_busy.current = false; };
	},
	[phone, onClose, onSuccess]);

	const footer =
	(
		<>
			<FormStatus { ...status } />

			<button type="button" aria-label="Fermer"
				className={ bemit('c-btn', ['green']) }
				onClick={ validate }>
				Confirmer
			</button>

			<button type="button" aria-label="Fermer"
				className={ props['close-classes'] || bemit('c-btn', ['grey']) }
				onClick={ exit }>
				Fermer
			</button>

			{
				loading ?
				(
					<Loader className="c-loader" bemit={ ['primary', 'bg-white'] }
						label="Mise à jour..."
					/>
				)
				: undefined
			}

		</>
	);

	const handleChange = useCallback(function (e)
	{
		setPhone(e.target.value || '');
	},
	[]);

	const content =
	(
		<>
			<FormStatus warning="Un numéro de tél. mobile est requis pour l'utilisation de la carte."
			/>

			<Input name="phone" label="N° de téléphone mobile"
				placeholder="Commence par 06, 07, +33 ou +34"
				bemit={ ['100%'] }
				onChange={ handleChange }
				value={ phone }
			/>

			<div className="u-margin-top-5" />
		</>
	);

	return (
		<Modal open={ props.open === true } onClose={ onClose }
			bemit={ modifiers } trg={ props.trg } footer={ footer }
			title="N° de téléphone mobile"
			prevent-close={ prevent_close }
			afterHidden={ handleModalHidden }>

			{ content }

		</Modal>
	);

	function exit (e)
	{
		_ref_ctrl.current?.abort?.();
		onClose(e);
	}
}